import React from 'react';

import StarsButton from '@swf/components/StarsButton/StarsButton';
import Translation from '@swf/components/Translation/Translation';

import InfoMessage from '../../../shared/InfoMessage/InfoMessage';
import AccountDate from '../../AccountDate/AccountDate';
import styles from '../../TakeABreakFromUs.scss';
import ExclusionRevocationFormConfirm from '../ExclusionRevocationFormConfirm/ExclusionRevocationFormConfirm';

import {
  TXTCLI_End_Self_Exclusion,
  TXTWCL_This_means_you_wonXt_be_able_t_ELL_17,
  TXTWCL_We_canXt_process_your_request__ELL_1,
  TXTWCL_You_can_request_to_end_your_se_ELL,
  TXTWCL_You_have_opted_to_end_your_sel_ELL
} from './ExclusionRevocationFormContent.messages.json';

interface Props {
  hasError: boolean;
  showConfirm: boolean;
  isPristine: boolean;
  invalidPassword: boolean;
  handleCancelForm: () => void;
  submittedRevocationTime?: number;
  formattedEndDate: JSX.Element;
  handleConfirmForm: () => void;
}
const ExclusionRevocationFormContent: React.FC<Props> = ({
  hasError,
  showConfirm,
  isPristine,
  invalidPassword,
  handleCancelForm,
  submittedRevocationTime,
  formattedEndDate,
  handleConfirmForm
}) => {
  switch (true) {
    case hasError:
      return (
        <InfoMessage type="error">
          <Translation {...TXTWCL_We_canXt_process_your_request__ELL_1} />
        </InfoMessage>
      );
    case !!submittedRevocationTime:
      return (
        <Translation
          {...TXTWCL_You_have_opted_to_end_your_sel_ELL}
          values={{ 0: <AccountDate date={new Date(submittedRevocationTime as number)} /> }}
        />
      );
    case showConfirm:
      return (
        <ExclusionRevocationFormConfirm
          handleCancel={handleCancelForm}
          invalidPassword={invalidPassword}
          pristine={isPristine}
        />
      );
    default:
      return (
        <>
          <Translation
            {...TXTWCL_This_means_you_wonXt_be_able_t_ELL_17}
            values={{ 0: formattedEndDate }}
          />{' '}
          <Translation {...TXTWCL_You_can_request_to_end_your_se_ELL} />
          <StarsButton
            className={styles.revocationButton}
            onClick={handleConfirmForm}
            block
            translation={TXTCLI_End_Self_Exclusion}
          />
        </>
      );
  }
};

export default ExclusionRevocationFormContent;
